import { BaseRouteService } from 'core/services';

class DashboardRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'dashboard/';
	}

	ordersSummary() {
		return super.get(this.base + 'orders-summary');
	}

	counts() {
		return super.get(this.base + 'counts');
	}

	shipByDate() {
		return super.get(this.base + 'ship-by-date');
	}

	orders(filter) {
		return super.get(this.base + 'orders{?warehouseId,sellerId,date,metric,status,isLtl}', null, filter);
	}

	carrierCbm() {
		return super.get(this.base + 'carrier-cbm');
	}

	completedCount(filter) {
		return super.get(this.base + 'completed-count{?metric,date}', null, filter);
	}

	statuses() {
		return super.get(this.base + 'statuses');
	}
}

export default DashboardRouteService;
